



















































































































import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import { apiWorkerTypeLists, apiWorkerTypeStatus, apiWorkerTypeDelete } from '@/api/staff'

@Component
export default class WorkerTypeList extends Vue {
    queryObj: any = {
      keyword: '',
      service_type: '',
      is_enabled: ''
    }

    tableData: any[] = []
    loading = false

    pager = new RequestPaging()
    getList (page?: number): void {
      page && (this.pager.page = page)
      this.loading = true
      this.pager
        .request({
          callback: apiWorkerTypeLists,
          params: {
            ...this.queryObj
          }
        })
        .then((res: any) => {
          this.tableData = res.lists || []
        })
        .finally(() => {
          this.loading = false
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        service_type: '',
        is_enabled: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/staff/worker-type/add')
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/staff/worker-type/edit', query: { id: row.id } })
    }

    handleToggleStatus (row: any) {
      const action = row.is_enabled ? '停用' : '启用'
      this.$confirm(`确定要${action}该工种吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiWorkerTypeStatus({
          id: row.id,
          is_enabled: row.is_enabled ? 0 : 1
        }).then(() => {
          this.$message.success(`${action}成功`)
          this.getList()
        })
      })
    }

    handleDelete (row: any) {
      this.$confirm(
        '确定要删除该工种吗？若该工种下仍有员工，或已绑定薪酬规则，系统将不允许删除。',
        '提示',
        {
          type: 'warning'
        }
      ).then(() => {
            apiWorkerTypeDelete({ ids: [row.id] }).then(() => {
                this.getList()
            })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.getList()
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.getList()
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    getServiceTypeText (type: number): string {
      const typeMap = ['', '维修/安装', '搬家保洁/回收']
      return typeMap[type] || '未知'
    }

    created () {
      this.getList()
    }

    activated () {
	    this.getList()
    }
}
